import { render, staticRenderFns } from "./RedirectSplash.vue?vue&type=template&id=51d6a312&"
import script from "./RedirectSplash.vue?vue&type=script&lang=js&"
export * from "./RedirectSplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2489941515/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51d6a312')) {
      api.createRecord('51d6a312', component.options)
    } else {
      api.reload('51d6a312', component.options)
    }
    module.hot.accept("./RedirectSplash.vue?vue&type=template&id=51d6a312&", function () {
      api.rerender('51d6a312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/RedirectSplash.vue"
export default component.exports